/* eslint-disable @next/next/no-img-element */
import { Button } from "@gonoodle/gn-universe-ui";
import PropTypes from "prop-types";

export default function ExternalLinkDisclaimer({ time, onClick }) {
  return (
    <div className="h-screen w-screen flex flex-col justify-center bg-white relative">
      <div className="flex flex-col items-center container text-center md:text-left">
        <div className="flex flex-col md:flex-row items-center space-y-md md:space-y-0 w-full md:max-w-screen-lg">
          <div className="w-full">
            <h2 className="gn-page-header-sm mb-md">
              You are about to leave GoNoodle.com
            </h2>
            <h2 className="gn-text md:gn-headline-sm mb-xl">
              This screen will disappear in {time}{" "}
              {time === 1 ? "second" : "seconds"}...
            </h2>
            <div className="my-sm">
              <Button
                size="md"
                mode="dark"
                label="Take me back to GoNoodle!"
                onClick={onClick}
              />
            </div>
          </div>
        </div>
        <div>&nbsp;</div>
      </div>
      <img
        className="w-3xl absolute bottom-0 right-0"
        src="https://cdn.gonoodle.com/Universe-Component-Library/general/shane-fonda-2.png"
        alt=""
      />
    </div>
  );
}

ExternalLinkDisclaimer.propTypes = {
  time: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
};
